import { type ImgHTMLAttributes } from "react";
import { cn } from "~/lib/utils";

export interface ArelloBackgroundProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  alt?: string;
}


const ArelloBackground = ({ className, alt = "", ...props }: ArelloBackgroundProps) => {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/ARL-background.png"
      alt={alt}
      className={cn("object-cover", className)}
      {...props}
    />
  );
};

export { ArelloBackground };

